import React, { useEffect } from "react";
import { MusicHallRegisEquipmentAdditionalStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const NO_EQUIPMENT_ID = "6930067e584aef3d9f8185cd";

const MusicHallRegisEquipmentAdditional = ({
  initialValues,
  equipmentOptions,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    additional_equipment_additional: yup.array().required("required"),
  });

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const { t } = useTranslation(["common", "form", "room"]);

  const selectedEquipment = watch("additional_equipment_additional");

  // Handle mutual exclusion between "No" and other options
  useEffect(() => {
    if (!selectedEquipment || selectedEquipment.length === 0) return;

    const hasNoEquipment = selectedEquipment.some(
      (item) => item.value === NO_EQUIPMENT_ID || item === NO_EQUIPMENT_ID,
    );
    const lastSelected = selectedEquipment[selectedEquipment.length - 1];
    const lastSelectedValue = lastSelected?.value || lastSelected;

    // If "No" was just selected, remove all other selections
    if (lastSelectedValue === NO_EQUIPMENT_ID && selectedEquipment.length > 1) {
      setValue(
        "additional_equipment_additional",
        selectedEquipment.filter(
          (item) => (item.value || item) === NO_EQUIPMENT_ID,
        ),
      );
    }
    // If another option was selected and "No" exists, remove "No"
    else if (
      hasNoEquipment &&
      lastSelectedValue !== NO_EQUIPMENT_ID &&
      selectedEquipment.length > 1
    ) {
      setValue(
        "additional_equipment_additional",
        selectedEquipment.filter(
          (item) => (item.value || item) !== NO_EQUIPMENT_ID,
        ),
      );
    }
  }, [selectedEquipment, setValue]);

  return (
    <MusicHallRegisEquipmentAdditionalStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="additional_layout">
          <div className="additional_text1">
            {t("Additional Equipment (Optional Extras)", { ns: "form" })}
          </div>
          <div className="additional_text2">
            (
            {t("Select additional topics if needed - extra charges may apply", {
              ns: "form",
            })}
            )
          </div>
          <div className="checkbox_layout">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.MultiCheckBox
                  {...field}
                  disabled={isDisabledForm}
                  options={
                    equipmentOptions
                    //   [
                    //   {
                    //     label: "Extra Wireless Microphone (500 THB/EACH)",
                    //     value: "1",
                    //   },
                    //   {
                    //     label:
                    //       "M3 Big Studio: Functioned as the judges’ lounge. (800 THB/Hour)",
                    //     value: "2",
                    //   },
                    //   {
                    //     label: "M1 Grand Piano (600 THB/Hour)",
                    //     value: "3",
                    //   },
                    //   {
                    //     label: "M2 Grand Piano (600 THB/Hour)",
                    //     value: "4",
                    //   },
                    //   { label: "M4 Grand Piano (600 THB/Hour)", value: "5" },
                    //   {
                    //     label: "S5 Upright Piano (400 THB/Hour)",
                    //     value: "6",
                    //   },
                    //   { label: "S6 Upright Piano (400 THB/Hour)", value: "7" },
                    //   { label: "S7 Upright Piano (400 THB/Hour)", value: "8" },
                    //   {
                    //     label:
                    //       "Stage Monitor (1000 THB/Pair) *Equipment rental only - sound set-up is not included.",
                    //     value: "9",
                    //   },
                    //   {
                    //     label: "1 Piano Stool",
                    //     value: "10",
                    //   },
                    //   {
                    //     label: "Extension Pedal",
                    //     value: "11",
                    //   },
                    //   {
                    //     label: "No",
                    //     value: "12",
                    //   },
                    // ]
                  }
                  errors={errors.additional_equipment_additional?.message}
                />
              )}
              name="additional_equipment_additional"
              defaultValue={[]}
            />
          </div>
        </div>
        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </MusicHallRegisEquipmentAdditionalStyled>
  );
};

MusicHallRegisEquipmentAdditional.propTypes = {};

export default MusicHallRegisEquipmentAdditional;
